import React from 'react';

import { WizardFormErrors } from '@futrli/ui-components/components/sidebar/wizard/types';

import { FormulaContentFormLexical } from '../formula-content-form/formula-content-form-lexical';
import { FormulaReferenceOption } from '../../../utils/formulas/types';
import { localizeFormula } from '../../../utils/formulas/i18n-utils';
import { OutputFrequency } from '../types';

interface FormulaContentLexicalProps {
  errors?: WizardFormErrors;
  formulaOptions?: FormulaReferenceOption[];
  formulaString?: string;
  isDisabled?: boolean;
  onFormulaChange?: (formula: string) => void;
  onOutputFrequencyChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onOutputOnDayChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onOutputOnMonthChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  outputFrequency?: OutputFrequency;
  outputOnDay?: string;
  outputOnMonth?: string;
  showFieldErrors?: boolean;
}

/**
 * Localizes the formula string on the way in and passes the localized formula string back out
 * unchanged via `onFormulaChange`, so de-localization at save time works as expected.
 */
export const FormulaContentLexical = ({
  errors,
  formulaOptions,
  formulaString = '',
  isDisabled,
  onFormulaChange,
  onOutputFrequencyChange,
  onOutputOnDayChange,
  onOutputOnMonthChange,
  outputFrequency,
  outputOnDay,
  outputOnMonth,
  showFieldErrors
}: FormulaContentLexicalProps) => {
  return (
    <FormulaContentFormLexical
      errors={errors}
      formulaContent={localizeFormula(formulaString)}
      initialEditorOptions={formulaOptions}
      isDisabled={isDisabled}
      onFormulaChange={onFormulaChange}
      onOutputFrequencyChange={onOutputFrequencyChange}
      onOutputOnDayChange={onOutputOnDayChange}
      onOutputOnMonthChange={onOutputOnMonthChange}
      outputFrequency={outputFrequency}
      outputOnDay={outputOnDay}
      outputOnMonth={outputOnMonth}
      showFieldErrors={showFieldErrors}
    />
  );
};
